
document.addEventListener('DOMContentLoaded', () => {
  const menuItems = document.querySelectorAll('.hover-menu-item');
  const margin = 8;

  function positionDropdown(item) {
    const menu = item.querySelector(':scope > .hover-submenu');
    if (!menu) return;

    const itemRect = item.getBoundingClientRect();

    // Use viewport positioning so the menu can be moved
    // independently of its original position in the page.
    menu.style.position = 'fixed';
    menu.style.left = `${itemRect.left}px`;
    menu.style.right = 'auto';
    menu.style.bottom = 'auto';
    menu.style.top = `${itemRect.bottom}px`;
    menu.style.maxHeight = 'none';
    menu.style.overflow = 'visible';

    requestAnimationFrame(() => {
      const rect = menu.getBoundingClientRect();

      // If the menu extends below the screen, move it up.
      if (rect.bottom > window.innerHeight - margin) {
        const top = Math.max(
          margin,
          window.innerHeight - rect.height - margin
        );

        menu.style.top = `${top}px`;
      }

      // Keep nested flyouts opening to the right.
      menu.querySelectorAll('.hover-subsubmenu').forEach((flyout) => {
        flyout.style.position = 'absolute';
        flyout.style.top = '0';
        flyout.style.bottom = 'auto';
        flyout.style.maxHeight = 'none';
        flyout.style.overflow = 'visible';
      });
    });
  }

  menuItems.forEach((item) => {
    item.addEventListener('mouseenter', () => {
      positionDropdown(item);
    });
  });

  window.addEventListener('resize', () => {
    document.querySelectorAll('.hover-menu-item:hover').forEach((item) => {
      positionDropdown(item);
    });
  });
});
